import { render } from "./headerBuscadorParaTi.vue?vue&type=template&id=45171125&scoped=true"
import script from "./headerBuscadorParaTi.vue?vue&type=script&lang=js"
export * from "./headerBuscadorParaTi.vue?vue&type=script&lang=js"

import "./headerBuscadorParaTi.vue?vue&type=style&index=0&id=45171125&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45171125"]])

export default __exports__